// DEPENDENCIES
import React from 'react';
import { compose } from 'redux';
import { useFormikContext } from 'formik';
import moment from 'moment';

// HELPERS
import { withRouter } from 'helpers/withRouter';

// LOCAL COMPONENTS
import Form from 'core/form/Form';
import Card from 'parts/card/Card';

export const DealCompletion = compose(withRouter)(() => {
  const { values } = useFormikContext() || {};
  const { aryChecklist } = values || {};

  return (
    <Form.Body>
      {Array.isArray(aryChecklist) &&
        aryChecklist
          .filter(v => !v.spot_instruction_id)
          .map(({ checklist_id, checklist_text, is_completed, date_updated, updated_by_fullname }, i) => (
            <Form.PlainText
              key={`${checklist_id}-${i}`}
              label={`Checklist Item ${i + 1}`}
              value={checklist_text}
              fullWidth
              text={
                is_completed
                  ? `Completed on ${moment(date_updated).format('MM/DD/YYYY')} at ${moment(date_updated).format(
                      'h:mm A'
                    )} by ${updated_by_fullname}`
                  : 'Incomplete'
              }
            />
          ))}
    </Form.Body>
  );
});

export default function DealCompletionInfo(props) {
  const { values } = useFormikContext() || {};
  return values && values.aryChecklist && values.aryChecklist?.length > 0 ? (
    <Card title={'Deal Completion Checklist'} body={<DealCompletion {...props} />} />
  ) : (
    <></>
  );
}
